module.exports = __webpack_public_path__ + "static/rj-9bbb1d0a4641dfed16d8856385ecf8af.jpg";